export const getUtmParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const hasUtm = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
  ].some((param) => urlParams.has(param));

  let utmParams;

  if (hasUtm) {
    utmParams = {
      utm_source: urlParams.get('utm_source'),
      utm_medium: urlParams.get('utm_medium'),
      utm_campaign: urlParams.get('utm_campaign'),
      utm_content: urlParams.get('utm_content'),
      utm_term: urlParams.get('utm_term'),
    };
    sessionStorage.setItem('utmParams', JSON.stringify(utmParams));
  } else {
    const stored = sessionStorage.getItem('utmParams');
    utmParams = stored ? JSON.parse(stored) : {};
  }

  return utmParams;
};
